import React from "react";
import styled from "styled-components";
import { layout, space, SpaceProps, LayoutProps } from "styled-system";
import { Box } from "../Box/Box";
import Logo from "../../assets/images/logo.svg";

const Component = styled.img<LayoutProps & SpaceProps>`
  ${layout}
  ${space}
  @media (max-width: 992px) {
    width: 103px;
    height: 51px;
  }
`;

export const VectorLogo: React.FC<LayoutProps & SpaceProps> = ({
  ...props
}) => (
  <Box {...props}>
    <Component alt="logo" src={Logo} />
  </Box>
);
